import KunLoading8 from './src/index'

KunLoading8.install = function (Vue) {
	Vue.component(KunLoading8.name, KunLoading8);
}

export default KunLoading8;
